import React from 'react';

import { getValidationRules } from '_helpers/forms/rules';

import {
  FIELDS_KEYS,
  DAY_OPTIONS,
  MONTH_OPTIONS,
  SUFFIX_OPTIONS,
  TITLE_OPTIONS,
  ACTIVITY_REASON_OPTIONS,
  DESIGNATOR_OPTIONS,
  STATE_OPTIONS,
  OWNER_TYPE,
} from '_constants/forms';

const fieldProps = {
  [FIELDS_KEYS.processingOption]: {
    name: FIELDS_KEYS.processingOption,
    required: true,
  },
  [FIELDS_KEYS.rush]: {
    name: FIELDS_KEYS.rush,
  },
  [FIELDS_KEYS.registeredAgent]: {
    name: FIELDS_KEYS.registeredAgent,
  },
  [FIELDS_KEYS.ein]: {
    name: FIELDS_KEYS.ein,
  },
  [FIELDS_KEYS.license]: {
    name: FIELDS_KEYS.license,
  },
  [FIELDS_KEYS.trademark]: {
    name: FIELDS_KEYS.trademark,
  },
  [FIELDS_KEYS.compliance]: {
    name: FIELDS_KEYS.compliance,
  },
  [FIELDS_KEYS.sCorp]: {
    name: FIELDS_KEYS.sCorp,
  },
  [FIELDS_KEYS.goodStanding]: {
    name: FIELDS_KEYS.goodStanding,
  },
  [FIELDS_KEYS.salesTaxPermit]: {
    name: FIELDS_KEYS.salesTaxPermit,
  },
  [FIELDS_KEYS.representativeFirstName]: {
    name: FIELDS_KEYS.representativeFirstName,
    label: 'First Name',
    required: true,
    onKeyPress: (event) => {
      if (!/[ a-zA-Z&\\-]/.test(event.key)) event.preventDefault();
    },
  },
  [FIELDS_KEYS.representativeMiddleName]: {
    name: FIELDS_KEYS.representativeMiddleName,
    label: 'Middle Name (optional)',
    required: false,
    onKeyPress: (event) => {
      if (!/[ a-zA-Z&\\-]/.test(event.key)) event.preventDefault();
    },
  },
  [FIELDS_KEYS.representativeLastName]: {
    name: FIELDS_KEYS.representativeLastName,
    label: 'Last Name',
    required: true,
    onKeyPress: (event) => {
      if (!/[ a-zA-Z&\\-]/.test(event.key)) event.preventDefault();
    },
  },
  [FIELDS_KEYS.representativeTitle]: {
    name: FIELDS_KEYS.representativeTitle,
    label: 'Title',
    placeholder: '',
    required: true,
    options: TITLE_OPTIONS,
  },
  [FIELDS_KEYS.representativeSuffix]: {
    name: FIELDS_KEYS.representativeSuffix,
    label: 'Suffix (optional)',
    placeholder: '',
    required: false,
    options: SUFFIX_OPTIONS,
  },
  [FIELDS_KEYS.customerFirstName]: {
    name: FIELDS_KEYS.customerFirstName,
    label: 'First Name',
    required: true,
    onKeyPress: (event) => {
      if (!/[ a-zA-Z&\\-]/.test(event.key)) event.preventDefault();
    },
  },
  [FIELDS_KEYS.customerMiddleName]: {
    name: FIELDS_KEYS.customerMiddleName,
    label: 'Middle Name (optional)',
    required: false,
    onKeyPress: (event) => {
      if (!/[ a-zA-Z&\\-]/.test(event.key)) event.preventDefault();
    },
  },
  [FIELDS_KEYS.customerLastName]: {
    name: FIELDS_KEYS.customerLastName,
    label: 'Last Name',
    required: true,
    onKeyPress: (event) => {
      if (!/[ a-zA-Z&\\-]/.test(event.key)) event.preventDefault();
    },
  },
  [FIELDS_KEYS.fullName]: {
    name: FIELDS_KEYS.fullName,
    label: 'Full Name',
    placeholder: 'Your Full Name',
    required: true,
    onKeyPress: (event) => {
      if (!/[ a-zA-Z&\\-]/.test(event.key)) event.preventDefault();
    },
  },
  [FIELDS_KEYS.email]: {
    name: FIELDS_KEYS.email,
    label: 'Email',
    placeholder: 'Your Email Address',
    required: true,
    type: 'email',
  },
  [FIELDS_KEYS.subject]: {
    name: FIELDS_KEYS.subject,
    label: 'Subject',
    placeholder: 'Subject',
    required: true,
  },
  [FIELDS_KEYS.message]: {
    name: FIELDS_KEYS.message,
    label: 'Message',
    placeholder: 'Your Message',
    required: true,
  },
  [FIELDS_KEYS.customerPhone]: {
    name: FIELDS_KEYS.customerPhone,
    label: 'Phone',
    required: true,
    type: 'phone',
    mask: '(000) 000-0000',
    placeholder: '(123) 456-7890',
  },
  [FIELDS_KEYS.customerEmail]: {
    name: FIELDS_KEYS.customerEmail,
    label: 'Email',
    required: true,
    type: 'email',
  },
  [FIELDS_KEYS.tradeName]: {
    name: FIELDS_KEYS.tradeName,
    required: true,
    label: 'Business Name',
  },
  [FIELDS_KEYS.legalName]: {
    name: FIELDS_KEYS.legalName,
    required: true,
    label: 'Business Name',
  },
  [FIELDS_KEYS.altCompanyName]: {
    name: FIELDS_KEYS.altCompanyName,
    required: true,
    label: 'Alternate Business Name',
  },
  [FIELDS_KEYS.designator]: {
    name: FIELDS_KEYS.designator,
    required: true,
    label: 'Designator',
    placeholder: 'Designator',
    options: DESIGNATOR_OPTIONS,
  },
  [FIELDS_KEYS.organizedState]: {
    name: FIELDS_KEYS.organizedState,
    required: true,
    label: 'Select state:',
    placeholder: 'State',
    options: STATE_OPTIONS,
  },
  [FIELDS_KEYS.activityPrimaryActivity]: {
    name: FIELDS_KEYS.activityPrimaryActivity,
    required: true,
    hint: 'Describe your type of business and primary activity and services you do or will provide',
    label: 'Business Category',
    placeholder: 'Select',
  },
  [FIELDS_KEYS.productDescription]: {
    name: FIELDS_KEYS.productDescription,
    required: true,
    placeholder: 'Specific Products or Services*',
    onKeyPress: (event) => {
      if (!/[ a-zA-Z.,]/.test(event.key)) event.preventDefault();
    },
  },
  [FIELDS_KEYS.activitySpecificProducts]: {
    name: FIELDS_KEYS.activitySpecificProducts,
    required: true,
    placeholder: 'Please select',
  },
  [FIELDS_KEYS.productExtraQuestion]: {
    name: FIELDS_KEYS.productExtraQuestion,
    required: true,
    placeholder: 'Please select',
  },
  [FIELDS_KEYS.physicalAddressAddress]: {
    name: FIELDS_KEYS.physicalAddressAddress,
    required: true,
    label: 'Street address',
  },
  [FIELDS_KEYS.physicalAddressAddress2]: {
    name: FIELDS_KEYS.physicalAddressAddress2,
    required: false,
    label: 'Street address 2',
  },
  [FIELDS_KEYS.physicalAddressCity]: {
    name: FIELDS_KEYS.physicalAddressCity,
    required: true,
    label: 'City',
    onKeyPress: (event) => {
      if (!/[ a-zA-Z/-]/.test(event.key)) event.preventDefault();
    },
  },
  [FIELDS_KEYS.physicalAddressZip]: {
    name: FIELDS_KEYS.physicalAddressZip,
    required: true,
    label: 'ZIP Code',
    maxLength: '5',
    onKeyPress: (event) => {
      if (!/[0-9]/.test(event.key)) event.preventDefault();
    },
  },
  [FIELDS_KEYS.physicalAddressState]: {
    name: FIELDS_KEYS.physicalAddressState,
    required: true,
    label: 'State',
    options: STATE_OPTIONS,
  },
  [FIELDS_KEYS.physicalAddressCounty]: {
    name: FIELDS_KEYS.physicalAddressCounty,
    required: true,
    label: 'County',
    onKeyPress: (event) => {
      if (!/[ a-zA-Z&-]/.test(event.key)) event.preventDefault();
    },
  },
  [FIELDS_KEYS.isMailingAddressSame]: {
    name: FIELDS_KEYS.isMailingAddressSame,
    label: 'Is your mailing address the same?',
    labelOff: 'No',
    labelOn: 'Yes',
  },
  [FIELDS_KEYS.mailingAddressAddress]: {
    name: FIELDS_KEYS.mailingAddressAddress,
    required: true,
    label: 'Street address',
  },
  [FIELDS_KEYS.mailingAddressAddress2]: {
    name: FIELDS_KEYS.mailingAddressAddress2,
    required: false,
    label: 'Street address 2',
  },
  [FIELDS_KEYS.mailingAddressCity]: {
    name: FIELDS_KEYS.mailingAddressCity,
    required: true,
    label: 'City',
    onKeyPress: (event) => {
      if (!/[ a-zA-Z/-]/.test(event.key)) event.preventDefault();
    },
  },
  [FIELDS_KEYS.mailingAddressZip]: {
    name: FIELDS_KEYS.mailingAddressZip,
    required: true,
    label: 'ZIP Code',
    maxLength: '5',
    onKeyPress: (event) => {
      if (!/[0-9]/.test(event.key)) event.preventDefault();
    },
  },
  [FIELDS_KEYS.mailingAddressState]: {
    name: FIELDS_KEYS.mailingAddressState,
    required: true,
    label: 'State',
    options: STATE_OPTIONS,
  },
  [FIELDS_KEYS.mailingAddressCounty]: {
    name: FIELDS_KEYS.mailingAddressCounty,
    required: true,
    label: 'County',
    onKeyPress: (event) => {
      if (!/[ a-zA-Z&-]/.test(event.key)) event.preventDefault();
    },
  },
  [FIELDS_KEYS.name]: {
    name: FIELDS_KEYS.name,
    required: true,
    onKeyPress: (event) => {
      if (!/[ 0-9a-zA-Z&\\-]/.test(event.key)) event.preventDefault();
    },
  },
  [FIELDS_KEYS.managedByMembers]: {
    name: FIELDS_KEYS.managedByMembers,
    labelOff: 'The LLC will be managed by managers(s)',
    labelOn: 'The LLC will be managed by member(s)',
  },
  [FIELDS_KEYS.acceptCreditCardPayments]: {
    name: FIELDS_KEYS.acceptCreditCardPayments,
    label: 'Will you accept Credit Card Payments?',
    labelOff: 'No',
    labelOn: 'Yes',
  },
  [FIELDS_KEYS.questionsFirstLLC]: {
    name: FIELDS_KEYS.questionsFirstLLC,
    label: 'Is this your first LLC?',
    labelOff: 'No',
    labelOn: 'Yes',
  },
  [FIELDS_KEYS.questionsHaveEmployee]: {
    name: FIELDS_KEYS.questionsHaveEmployee,
    label: 'Will you have employees?',
    labelOff: 'No',
    labelOn: 'Yes',
  },
  [FIELDS_KEYS.questionsStartedDoingBusiness]: {
    name: FIELDS_KEYS.questionsStartedDoingBusiness,
    label: 'Have you started doing business?',
    labelOff: 'No',
    labelOn: 'Yes',
  },
  //
  [FIELDS_KEYS.questionsHighway]: {
    name: FIELDS_KEYS.questionsHighway,
    hint: (
      <>
        Please select yes if this applies to your business.
        <br />
        The most common answer to this question is No.
      </>
    ),
    label:
      'Does your business own a highway motor vehicle weighing 55,000 pounds or more?',
    labelOff: 'No',
    labelOn: 'Yes',
  },
  [FIELDS_KEYS.questionsGambling]: {
    name: FIELDS_KEYS.questionsGambling,
    hint: (
      <>
        Please select yes if this applies to your business.
        <br />
        The most common answer to this question is No.
      </>
    ),
    label: 'Does your business involve gambling?',
    labelOff: 'No',
    labelOn: 'Yes',
  },
  [FIELDS_KEYS.questionsATF]: {
    name: FIELDS_KEYS.questionsATF,
    hint: (
      <>
        Please select yes if this applies to your business.
        <br />
        The most common answer to this question is No.
      </>
    ),
    label:
      'Does your business sell or manufacture alcohol, tobacco, or firearms?',
    labelOff: 'No',
    labelOn: 'Yes',
  },
  [FIELDS_KEYS.questionsExcise]: {
    name: FIELDS_KEYS.questionsExcise,
    hint: (
      <>
        Please select yes if this applies to your business.
        <br />
        The most common answer to this question is No.
      </>
    ),
    label: 'Does your business pay federal excise taxes?',
    labelOff: 'No',
    labelOn: 'Yes',
  },
  [FIELDS_KEYS.questionsAppliedBefore]: {
    name: FIELDS_KEYS.questionsAppliedBefore,
    hint: (
      <>
        Please select yes if this applies to your business.
        <br />
        The most common answer to this question is No. If you select yes,
        provide details in the fields that will appear below.
      </>
    ),
    label: 'Is this your first LLC?',
    labelOff: 'No',
    labelOn: 'Yes',
  },
  [FIELDS_KEYS.payEmployeesViaPayroll]: {
    name: FIELDS_KEYS.payEmployeesViaPayroll,
    label: 'Does your business plan to pay employees via payroll?',
    labelOff: 'No',
    labelOn: 'Yes',
  },
  [FIELDS_KEYS.questionsHire]: {
    name: FIELDS_KEYS.questionsHire,
    label:
      'Do you currently have, or plan to hire employees within the next year (not including owners)?',
    labelOff: 'No',
    labelOn: 'Yes',
  },
  [FIELDS_KEYS.payLessThan4k]: {
    name: FIELDS_KEYS.payLessThan4k,
    hint: (
      <>
        Do you have, or do you expect to have, any employees who will receive
        Forms W-2 in the next 12 months?
        <br />A Form W-2 (Wage and Tax Statement) is issued by an employer to
        his or her employees showing taxes deducted from their yearly pay. Taxes
        covered on the W-2 are: federal income tax, Social Security tax and
        Medicare tax
      </>
    ),
    label:
      'Do you expect your employment tax liability to be $1,000 or less in a full calendar year? (January-December)?',
    labelOff: 'No',
    labelOn: 'Yes',
  },
  [FIELDS_KEYS.annualTaxes]: {
    name: FIELDS_KEYS.annualTaxes,
    label: 'Do you want to file employment tax annually instead of quarterly?',
    labelOff: 'No',
    labelOn: 'Yes',
  },
  //
  [FIELDS_KEYS.cardNumber]: {
    name: FIELDS_KEYS.cardNumber,
    required: true,
    label: 'Card Number',
    placeholder: '0000 0000 0000 0000',
  },
  [FIELDS_KEYS.cvc]: {
    name: FIELDS_KEYS.cvc,
    type: 'password',
    required: true,
    label: 'CVC/CVV',
    placeholder: 'CVC',
    maxLength: '4',
    onKeyPress: (event) => {
      if (!/[\d{3,4}]/.test(event.key)) {
        event.preventDefault();
      }
    },
  },
  [FIELDS_KEYS.cardMonth]: {
    name: FIELDS_KEYS.cardMonth,
    required: true,
    label: 'Expiration date',
    placeholder: 'Month',
    options: MONTH_OPTIONS,
  },
  [FIELDS_KEYS.cardYear]: {
    name: FIELDS_KEYS.cardYear,
    required: true,
    placeholder: 'Year',
  },
  [FIELDS_KEYS.firstName]: {
    name: FIELDS_KEYS.firstName,
    label: 'First Name',
    placeholder: 'Enter First Name',
    required: true,
    onKeyPress: (event) => {
      if (!/[ a-zA-Z&\\-]/.test(event.key)) event.preventDefault();
    },
  },
  [FIELDS_KEYS.middleName]: {
    name: FIELDS_KEYS.middleName,
    label: 'Middle Name (optional)',
    placeholder: 'Enter Middle Name',
    required: false,
    onKeyPress: (event) => {
      if (!/[ a-zA-Z&\\-]/.test(event.key)) event.preventDefault();
    },
  },
  [FIELDS_KEYS.lastName]: {
    name: FIELDS_KEYS.lastName,
    label: 'Last Name',
    placeholder: 'Enter Last Name',
    required: true,
    onKeyPress: (event) => {
      if (!/[ a-zA-Z&\\-]/.test(event.key)) event.preventDefault();
    },
  },
  [FIELDS_KEYS.billingAddressAddress1]: {
    name: FIELDS_KEYS.billingAddressAddress1,
    required: true,
    label: 'Billing Address',
    placeholder: 'Enter Address',
  },
  [FIELDS_KEYS.billingAddressCity]: {
    name: FIELDS_KEYS.billingAddressCity,
    required: true,
    label: 'City',
    placeholder: 'Enter City Name',
    onKeyPress: (event) => {
      if (!/[ a-zA-Z/-]/.test(event.key)) event.preventDefault();
    },
  },
  [FIELDS_KEYS.billingAddressState]: {
    name: FIELDS_KEYS.billingAddressState,
    required: true,
    label: 'State',
    placeholder: 'Select a state',
    options: STATE_OPTIONS,
  },
  [FIELDS_KEYS.billingAddressZip]: {
    name: FIELDS_KEYS.billingAddressZip,
    required: true,
    label: 'ZIP Code',
    placeholder: 'Enter ZIP Code',
    maxLength: '5',
    onKeyPress: (event) => {
      if (!/[0-9]/.test(event.key)) event.preventDefault();
    },
  },
  [FIELDS_KEYS.agreeWithTerms]: {
    name: FIELDS_KEYS.agreeWithTerms,
    label:
      'I accept the terms. I have read, understand, & agree to the terms of service.',
  },
  [FIELDS_KEYS.file]: {
    name: FIELDS_KEYS.file,
    required: true,
    type: 'file',
    // accept: '.png,.jpg,.jpeg,.pdf',
  },
  [FIELDS_KEYS.dateOfBirthDay]: {
    name: FIELDS_KEYS.dateOfBirthDay,
    required: true,
    placeholder: 'Day',
    options: DAY_OPTIONS,
  },
  [FIELDS_KEYS.dateOfBirthMonth]: {
    name: FIELDS_KEYS.dateOfBirthMonth,
    required: true,
    placeholder: 'Month',
    options: MONTH_OPTIONS,
  },
  [FIELDS_KEYS.dateOfBirthYear]: {
    name: FIELDS_KEYS.dateOfBirthYear,
    required: true,
    placeholder: 'Year',
  },
  [FIELDS_KEYS.ssn]: {
    name: FIELDS_KEYS.ssn,
    required: true,
    mask: '000-00-0000',
    placeholder: 'XXX-XX-XXXX',
  },
  [FIELDS_KEYS.driverLicenceOrID]: {
    name: FIELDS_KEYS.driverLicenceOrID,
    required: true,
  },
  [FIELDS_KEYS.ownerType]: {
    name: FIELDS_KEYS.ownerType,
    required: true,
    options: [
      {
        label: 'Individual',
        value: OWNER_TYPE.individual,
      },
      {
        label: 'Organization',
        value: OWNER_TYPE.organization,
      },
    ],
  },
};

export const getFieldProps = (fieldKey, { validationOptions } = {}) => {
  const props = fieldProps[fieldKey];
  return props
    ? { ...props, rules: getValidationRules(fieldKey, validationOptions) }
    : {};
};
